// Imports
import React from "react"
import { generateString } from "@utils"
import { AudianceCard } from "@molecules"

export const AudiancesCardWrapper = ({ cardCategories }) => {
  return (
    <>
      {cardCategories.map((category, index) => {
        return (
          <div className="audiances-cards__category" key={index}>
            <div className="audiances-cards__category-title">
              <span>{category.category}</span>
              <span></span>
            </div>
            <div
              className={`audiances-cards__category-cards ${
                category.category !== cardCategories[0].category
                  ? "secondary"
                  : ""
              }`}
            >
              {category.items.map((audiance, index) => {
                return (
                  <React.Fragment key={generateString(30)}>
                    <AudianceCard
                      subtitle={audiance.subtitle}
                      title={audiance.title}
                      desc={audiance.description.description}
                      image={audiance.illustration.gatsbyImageData}
                      link={audiance.link}
                      index={index}
                    />
                  </React.Fragment>
                )
              })}
            </div>
          </div>
        )
      })}
    </>
  )
}
